import { portalApi } from '@/axios'

import { Trace } from '@/classes/models'

export default class TraceService {
  /**
   * Get a trace by reference.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static get (context, reference, isAdvanced) {
    let request = portalApi.get(`${this.endpoint(context)}/${reference}`, {
      params: typeof isAdvanced !== 'undefined' ? { advanced: isAdvanced } : null
    }).then(response => {
      return response.data
    })

    return request.then(response => {
      // Map to trace
      response.data = new Trace(response.data)

      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business', 'merchant', 'configuration'])}/traces`
  }
}
